/**
 * Student Billing Summary API Client
 *
 * Handles operations for student billing summaries with Cognito authentication.
 */

// API Gateway URL
const API_BASE_URL = 'https://jrgfnay5w2.execute-api.ap-southeast-2.amazonaws.com/v1';

/**
 * Get the authentication token from the user's session.
 */
const getAuthToken = () => {
  const oidcStorage = sessionStorage.getItem('oidc.user:https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_3n9j6gDzL:2c6na652k2lkcsaa1ol8m5chp4');
  if (oidcStorage) {
    try {
      const oidcData = JSON.parse(oidcStorage);
      return oidcData.id_token || oidcData.access_token;
    } catch (e) {
      console.error('Error parsing OIDC storage:', e);
    }
  }
  return null;
};

/**
 * Make an authenticated API request.
 */
const apiRequest = async (operation, data = {}) => {
  const token = getAuthToken();

  if (!token) {
    throw new Error('Not authenticated. Please log in again.');
  }

  const response = await fetch(`${API_BASE_URL}/student-billing-summary`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      operation,
      data
    })
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || `Request failed with status ${response.status}`);
  }

  return result;
};

/**
 * Get billing summary for a specific student.
 *
 * @param {string} studentId - Student ID
 */
export const getStudentBillingSummary = async (studentId) => {
  const result = await apiRequest('getSummary', { studentId });
  return result.summary;
};

/**
 * List billing summaries for all students.
 *
 * @param {Object} filters - Optional filters
 * @param {string} filters.campusId - Filter by campus ID
 */
export const listStudentBillingSummaries = async (filters = {}) => {
  const result = await apiRequest('listSummaries', filters);
  return {
    summaries: result.summaries || [],
    requesterCampusId: result.requesterCampusId
  };
};

const studentBillingSummaryApi = {
  getStudentBillingSummary,
  listStudentBillingSummaries
};

export default studentBillingSummaryApi;
